import './TextContent.scss'

const TextContent = () => {
    return (
        <>
        <div className="home-content">
            <div className="tag-line">
            <h1>Get Instant Digital Payments For Everyone.</h1>
            </div>
            <div className="message">
            <span>Pay it easy with PIE e-Wallet. Provides easy payment services worldwide. Save your time.</span>
            </div>
        </div>
        </>
    )
}

export default TextContent
